module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門3_2.39f2466b.png";